<template>
  <div>
    <Modal
      background-color="rgba(0,0,0,.7)"
      :active.sync="modalAtivo"
      title="Histórico de Alterações"
      fullscreen
      @close="fecharModal"
    >
      <vs-row class="mb-8">
        <vs-col vs-w="6">
          <span class="text-xl text-black">
            {{
              tipo && tipo !== ''
                ? nome && nome !== ''
                  ? `${tipo} - ${nome}`
                  : tipo
                : ''
            }}
          </span>
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="end"
          ><vs-input
            icon="search"
            icon-after="true"
            placeholder="Usuário"
            v-model="usuarioBuscado"
        /></vs-col>
      </vs-row>

      <vs-row
        class="mb-6 divider"
        v-for="(item, index) in historico"
        :key="index"
      >
        <vs-col
          ><span class="text-xl font-bold text-black">{{ item.data }}</span>
          <vs-row
            class="mb-4"
            v-for="(itemDados, indexDados) in item.dados"
            :key="indexDados"
          >
            <vs-col
              :class="`flex flex-col ${aplicaBackgroud(indexDados)}`"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
              ><span class="text-lg font-semibold">Referência</span
              ><span>{{ itemDados.tabela }}</span></vs-col
            >
            <vs-col
              :class="`flex flex-col ${aplicaBackgroud(indexDados)}`"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
              ><span class="text-lg font-semibold">Campo</span
              ><span>{{ itemDados.campo }}</span></vs-col
            >
            <vs-col
              :class="`flex flex-col ${aplicaBackgroud(indexDados)}`"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
              ><span class="text-lg font-semibold">Anterior</span
              ><span>{{ itemDados.dadoOld }}</span></vs-col
            >
            <vs-col
              :class="`flex flex-col ${aplicaBackgroud(indexDados)}`"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
              ><span class="text-lg font-semibold">Posterior</span
              ><span>{{ itemDados.dadoNew }}</span></vs-col
            >
            <vs-col
              :class="`flex flex-col ${aplicaBackgroud(indexDados)}`"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
              ><span class="text-lg font-semibold">{{
                itemDados.isProspect ? 'Associado' : 'Usuário'
              }}</span
              ><span>{{ itemDados.nome }}</span></vs-col
            >
            <vs-col
              :class="`flex flex-col ${aplicaBackgroud(indexDados)}`"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
              ><span class="text-lg font-semibold">Hora</span
              ><span>{{ itemDados.hora }}</span></vs-col
            >
          </vs-row>
        </vs-col>
      </vs-row>
    </Modal>
  </div>
</template>
<script>
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import service from '../../services';
import Modal from '../../components/Modal.vue';

export default {
  name: 'Modal-Historico-Alteracoes',
  components: { Modal },
  props: ['popupActive', 'tipo', 'nome', 'dadosConsulta'],
  data() {
    return {
      modalAtivo: false,
      historicoDados: [],
      usuarioBuscado: '',
      functions,
    };
  },
  created() {},
  mounted() {},
  watch: {
    popupActive() {
      if (this.popupActive) {
        this.buscarHistorico();
      }
    },
  },
  computed: {
    historico() {
      return this.filtrarUsuarios();
    },
  },
  methods: {
    async buscarHistorico() {
      try {
        this.$vs.loading();
        let res = await service.post(
          'Logs',
          'buscar-historico',
          this.dadosConsulta,
        );

        if (res.data.length) {
          // SEGURADORA
          // POG
          res.data = this.trocaTabelaAssociadoPorSegurado(res.data);
          // POG

          this.historicoDados = functions.organizarEmDias(res.data);
          this.modalAtivo = true;
        } else {
          notify.notifyCustonColor(
            this.$vs,
            'Não há resgistro de alterações',
            'Atenção',
            'warning',
          );
          this.$emit('close');
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        this.$emit('close');
      } finally {
        this.$vs.loading.close();
      }
    },
    aplicaBackgroud(index) {
      return index % 2 === 0 ? 'background' : '';
    },
    filtrarUsuarios() {
      const filtro = this.historicoDados
        .flatMap((h) => h.dados)
        .filter((u) =>
          u.nome.toLowerCase().includes(this.usuarioBuscado.toLowerCase()),
        );

      return functions.organizarEmDias(filtro);
    },
    fecharModal() {
      this.usuarioBuscado = '';
      this.$emit('close');
    },

    // POG
    trocaTabelaAssociadoPorSegurado(data) {
      return data.map((d) => {
        if (d.tabela === 'associados') {
          return {
            ...d,
            tabela: 'Segurados',
          };
        } else if (d.tabela === 'regionais') {
          return {
            ...d,
            tabela: 'Corretoras',
          };
        } else if (d.tabela === 'divisoes') {
          return {
            ...d,
            tabela: 'Assessorias',
          };
        } else {
          return d;
        }
      });
    },
  },
};
</script>
<style scoped>
.divider {
  border: 0.1rem solid #e3e3e3;
}

.background {
  background: #e7e7e7;
}
</style>
